__turbopack_context__.v({
  "imageContainer": "styles-module-scss-module__ADZUgW__imageContainer",
  "imagesContainer": "styles-module-scss-module__ADZUgW__imagesContainer",
  "pillOptionsContainer": "styles-module-scss-module__ADZUgW__pillOptionsContainer",
  "scrollDesktop": "styles-module-scss-module__ADZUgW__scrollDesktop",
  "scrollMobile": "styles-module-scss-module__ADZUgW__scrollMobile",
});
